import { FrontEndDataApi } from "~/api/FrontendData";

export function useFrontEndDataApi(): FrontEndDataApi {  
  const frontEndDataApi = new FrontEndDataApi(useHttpClient());
  return frontEndDataApi;
}
